// array of genres

export const arrOfGenres = ['Shonen', 'Isekai', 'Horror', 'Slice-of-Life']

//array of watchstatus

export const arrOfWatchStatus = ['Finished', 'Dropped', 'Incomplete']

// array of genre options
export const arrOfGenresOptions = ['All Genres', 'Shonen', 'Isekai', 'Horror', 'Slice of Life']